import axiosRequest from '@/utils/axios-default-request';

// 获取供应商实名认证form表单
let getSupSmrzFromData  = (data)=>axiosRequest.postBody('/supinterface/getSupSmrzFromData',data)

// 获取供应商实名认证展示信息
let getSupSmrzData  = (data)=>axiosRequest.postBody('/supinterface/getSupSmrzData',data)


// 添加/编辑供应商实名认证 addOrEditSupSmrz
let addOrEditSupSmrz  = (data)=>axiosRequest.postBodyJson('/supinterface/addOrEditSupSmrz',data)

/** 绑定银行卡 */
// 查询结算认证信息 getJSRZData  
let getJSRZData  = (data)=>axiosRequest.postBody('/supinterface/getJSRZData',data)

// 查询省市信息 getProvincesCities 
let getProvincesCities  = (data)=>axiosRequest.postBody('/supinterface/getProvincesCities',data)

//添加/编辑结算认证 addOrEditJSRZ SupJsrz（实体类）
let addOrEditJSRZ  = (data)=>axiosRequest.postBodyJson('/supinterface/addOrEditJSRZ',data)





export default{
    getSupSmrzFromData,// 获取供应商实名认证form表单
    getSupSmrzData,// 获取供应商实名认证展示信息
    addOrEditSupSmrz,//编辑或新增实名认证

    getJSRZData,//查询结算认证信息form
    getProvincesCities,//查询省市信息
    addOrEditJSRZ,//添加/编辑结算认证
}